/**
 * Pure event-day reminder decisions. No Firebase.
 * Send time is 11:00 Europe/Sarajevo (11:00 CEST in summer, 11:00 CET in winter).
 */

import { calendarDayKey, getEventCalendarDay } from '../../../services/shared/dateUtils';

export const EVENT_DAY_TIMEZONE = 'Europe/Sarajevo';
export const EVENT_DAY_SEND_MINUTES = 11 * 60;
export const EVENT_DAY_REMINDERS_COLLECTION = 'eventDayReminders';

export function safeReminderPart(value) {
  return String(value || '').replace(/[~*/.[\]#]/g, '_');
}

export function eventDayReminderId(uid, eventId) {
  return `${uid}_${safeReminderPart(eventId)}`;
}

export function eventDayNotifId(eventId, uid) {
  return `event_day_${safeReminderPart(eventId)}_${uid}`;
}

export function sarajevoDayKey(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: EVENT_DAY_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

export function sarajevoMinutes(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: EVENT_DAY_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(now);
  const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);
  const minute = Number(parts.find((part) => part.type === 'minute')?.value || 0);
  return (hour === 24 ? 0 : hour) * 60 + minute;
}

export function isEventDaySendWindow(now = new Date()) {
  return sarajevoMinutes(now) >= EVENT_DAY_SEND_MINUTES;
}

export function eventDayKeyFromEvent(event) {
  const day = getEventCalendarDay(event);
  return day ? calendarDayKey(day) : '';
}

/** @returns {'delete' | 'skip' | 'upsert'} */
export function planEventDayReminder({ dayKey, existing, todayKey }) {
  if (!dayKey || dayKey < todayKey) return 'delete';
  if (existing?.status === 'sent' && existing.dayKey === dayKey) return 'skip';
  return 'upsert';
}
